import { Box, Button, FormControl, Grid, Stack, Typography } from '@mui/material';
import { DataGrid, gridClasses, GridColDef, GridRenderCellParams } from '@mui/x-data-grid';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../reducers';
import { useAppDispatch } from '../../../store/store';
import Loading from '../../Shared/Loading';
import { fetchHeidiSessionExceptionsReport, setEndDate, setStartDate } from '../../../store/heidiSessionExceptionsReport.slice';
import { localDateAndTimeFormat } from '../../../utils/timeFormat';

const HeidiSessionExceptionsReport = () => {
    const dispatch = useAppDispatch();
    const { startDate, endDate, rowData } = useSelector((state: RootState) => state.heidiSessionExceptionsReport);
    const [paginationModel, setPaginationModel] = useState({ pageSize: 15, page: 0 });

    useEffect(() => {
        dispatch(fetchHeidiSessionExceptionsReport(startDate, endDate));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const columns: GridColDef[] = [
        {
            field: 'CreatedAt',
            headerName: 'Created On',
            minWidth: 130,
            flex: 1,
            renderCell: (params: GridRenderCellParams) => {
                if (!params.value) {
                    return <Typography variant="body2">-</Typography>;
                }

                return <Typography variant="body2">{localDateAndTimeFormat(new Date(params.value))}</Typography>;
            },
        },
        { field: 'ProviderName', headerName: 'Provider', minWidth: 160, flex: 1 },
        { field: 'SelectedRole', headerName: 'Role', minWidth: 140, flex: 1 },
        { field: 'MemberId', headerName: 'Member Id', minWidth: 170, flex: 1 },
        { field: 'AiSessionId', headerName: 'Session Id', minWidth: 170, flex: 1 },
        { field: 'AssessmentName', headerName: 'Assessment', minWidth: 180, flex: 1 },
        { field: 'ExceptionMessage', headerName: 'Exception Message', minWidth: 280, flex: 2 },
        { field: 'StackTrace', headerName: 'Stack Trace', minWidth: 400, flex: 3 },
    ];

    return (
        <LocalizationProvider dateAdapter={AdapterDateFns}>
            <Grid container>
                <Box width={'100%'} borderBottom={1} paddingBottom={1} marginBottom={1}>
                    <Typography fontWeight="fontWeightMedium" component="h3">
                        Heidi Session Exceptions
                    </Typography>
                </Box>
                <Loading message={'Loading...'} />
                <Grid size={12}>
                    <Stack width="100%" direction="row" alignItems="center" marginY={2} className="float-right" spacing={3}>
                        <FormControl className="form-control-200">
                            <DesktopDatePicker
                                label="Start Date:"
                                value={startDate}
                                minDate={new Date('2017-01-01')}
                                onChange={(newValue) => {
                                    dispatch(setStartDate(newValue));
                                }}
                                slotProps={{ textField: {} }}
                            />
                        </FormControl>
                        <FormControl className="form-control-200">
                            <DesktopDatePicker
                                label="End Date:"
                                value={endDate}
                                minDate={new Date('2017-01-01')}
                                onChange={(newValue) => {
                                    dispatch(setEndDate(newValue));
                                }}
                                slotProps={{ textField: {} }}
                            />
                        </FormControl>
                        <Button
                            style={{ minWidth: '120px', marginRight: 'auto' }}
                            onClick={() => dispatch(fetchHeidiSessionExceptionsReport(startDate, endDate))}
                            variant="contained"
                            color="primary"
                        >
                            Search
                        </Button>
                    </Stack>
                </Grid>
                <Grid style={{ height: '80vh', width: '100%' }}>
                    <DataGrid
                        rows={rowData}
                        columns={columns}
                        paginationModel={paginationModel}
                        onPaginationModelChange={setPaginationModel}
                        pageSizeOptions={[5, 10, 15, 25]}
                        getRowId={(row) => row.Id}
                        getRowHeight={() => 'auto'}
                        sx={{
                            [`& .${gridClasses.cell}`]: {
                                py: 1,
                            },
                        }}
                    />
                </Grid>
            </Grid>
        </LocalizationProvider>
    );
};

export default HeidiSessionExceptionsReport;
